import { useState } from "react";

import { usePostHog } from "posthog-js/react";

import { useCompanyProfile, useWriterComponentState } from "hooks";

import { CreateCompanyReviewMenu } from "./CreateCompanyReviewMenu";
import { ClientAppEvent, CompanyReviewSource } from "../../constants";

interface Props {
  companyId: number;
  onReviewSubmittedRefresh: VoidFunction;
  onModalClose: VoidFunction;
}

export function CreateCompanyReviewMenuContainer(props: Props) {
  const { companyId, onReviewSubmittedRefresh, onModalClose } = props;
  const { companyProfile } = useCompanyProfile(companyId);
  const posthog = usePostHog();
  const [review, setReview] = useState<string>("");
  const [rating, setRating] = useState<CompanyRatingValue | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const setReviewText = (val: string) => {
    setReview(val);
  };

  const setReviewRating = (val: CompanyRatingValue | null) => {
    setRating(val);
  };

  const { loading, write, error } = useWriterComponentState({
    errorMessage:
      "Failed to create ETA. Please contact us if the issue persists.",
    writeConfig: {
      method: "post",
      url: `/companies/${companyId}/reviews`,
      body: {
        rating,
        text: review,
        source: CompanyReviewSource.CARRIER_PROFILE,
      },
    },
    errorMessageKey: "message",
  });

  const onSubmit = () => {
    if (rating != null) {
      write(() => {
        posthog?.capture(ClientAppEvent.COMPANY_REVIEW_SUBMITTED, {
          carrier_company_id: companyId,
          shipment_id: null,
          rating,
          has_text_review: review.length > 0,
          source: CompanyReviewSource.CARRIER_PROFILE,
        });
        onReviewSubmittedRefresh();
        setSuccess(true);
        onModalClose();
      });
    }
  };

  return (
    <CreateCompanyReviewMenu
      setReviewText={setReviewText}
      setReviewRating={setReviewRating}
      onSubmit={onSubmit}
      canSubmit={rating != null}
      companyProfile={companyProfile}
      rating={rating}
      error={error}
      loading={loading}
      success={success}
    />
  );
}
